import { createFileRoute } from '@tanstack/react-router';
import React from 'react';

import DebugTrainingSnapshotRoute from '~/debug/DebugTrainingSnapshotRoute';

export const Route = createFileRoute('/debug/training/$snapshotId')({
  component: DebugTrainingSnapshotRouteWrapper,
});

function DebugTrainingSnapshotRouteWrapper() {
  const { snapshotId } = Route.useParams();
  return <DebugTrainingSnapshotRoute snapshotIdParam={snapshotId} />;
}
